import { Button, Card, CardDescription, CardTitle } from "@conlit/ui";
import type { FallbackProps } from "react-error-boundary";
import { Link } from "react-router";
import { useLocale } from "@/features/localisation/locale-context";

export function LoadingState({ label }: { label?: string }) {
  const { t } = useLocale();
  return (
    <div role="status" className="p-8 text-center">
      <span className="sr-only">{label ?? t("common.loading")}</span>
      <div
        aria-hidden
        className="border-information-border border-t-participation mx-auto size-8 animate-spin rounded-full border-4 motion-reduce:animate-none"
      />
    </div>
  );
}
export function EmptyState({ title, description }: { title?: string; description?: string }) {
  const { locale } = useLocale();
  return (
    <Card className="mx-auto max-w-xl text-center">
      <CardTitle>{title ?? (locale === "th" ? "ยังไม่มีข้อมูล" : "Nothing here yet")}</CardTitle>
      <CardDescription>
        {description ??
          (locale === "th"
            ? "ข้อมูลจะแสดงเมื่อพร้อมใช้งาน"
            : "Content will appear here when it is available.")}
      </CardDescription>
    </Card>
  );
}
export function UnauthorisedState() {
  const { t } = useLocale();
  return (
    <main id="main-content" className="mx-auto max-w-3xl p-8">
      <Card>
        <CardTitle>{t("error.unauthorisedTitle")}</CardTitle>
        <CardDescription>{t("error.unauthorisedDescription")}</CardDescription>
        <Button asChild className="mt-6">
          <Link to="/">{t("error.returnHome")}</Link>
        </Button>
      </Card>
    </main>
  );
}
export function GlobalErrorState({ resetErrorBoundary }: FallbackProps) {
  const { t } = useLocale();
  return (
    <main className="mx-auto max-w-3xl p-8">
      <Card role="alert">
        <CardTitle>{t("error.genericTitle")}</CardTitle>
        <CardDescription>{t("error.genericDescription")}</CardDescription>
        <Button className="mt-6" onClick={resetErrorBoundary}>
          {t("common.retry")}
        </Button>
      </Card>
    </main>
  );
}
export function RouteErrorState() {
  const { t } = useLocale();
  return (
    <main className="mx-auto max-w-3xl p-8">
      <Card role="alert">
        <CardTitle>{t("error.pageTitle")}</CardTitle>
        <CardDescription>{t("error.pageDescription")}</CardDescription>
        <Button asChild className="mt-6">
          <Link to="/">{t("error.returnHome")}</Link>
        </Button>
      </Card>
    </main>
  );
}
